import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { updateClasses } from '../_store/middlewares/settings.middleware';

const useSettingsStore = create(
  persist(
    (set, get) => ({
      settings: {
        theme: 'themes/theme-g.css', // Default theme
        isFixed: true,
        isCollapsed: false,
        isBoxed: false,
        isFloat: false,
        asideHover: false,
        asideScrollbar: false,
        isCollapsedText: false,
        offsidebarOpen: false,
        asideToggled: false,
        showUserBlock: false,
        horizontal: false,
        useFullLayout: false,
        hiddenFooter: false,
        language: 'en', // Default language
      },

      // Toggle a specific setting
      toggleSetting: (key) => {
        set((state) => {
          const updatedSettings = {
            ...state.settings,
            [key]: !state.settings[key],
          };

          updateClasses({ settings: updatedSettings });
          return { settings: updatedSettings };
        });
      },

      // Change a specific setting to a specific value
      changeSetting: (key, value) => {
        set((state) => {
          const updatedSettings = {
            ...state.settings,
            [key]: value,
          };
          updateClasses({ settings: updatedSettings });

          // Apply theme dynamically if the key is 'theme'
          if (key === 'theme') {
            const linkElement = document.getElementById('theme-stylesheet');
            if (linkElement) {
              linkElement.href = value;
            }
          }

          return { settings: updatedSettings };
        });
      },
    }),
    {
      name: 'settings-storage', // Name for localStorage persistence
    }
  )
);

export default useSettingsStore;
